import { types } from "../../Actions/types";

const initialState = {
  primarymusclelist: [],
  error: null,
  primaryMuscleSingle: "",
  popupmodel: "",
};

const PrimaryMuscle = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.PRIMARY_MUSCLE_LIST:
      return {
        ...state,
        primarymusclelist: payload,
        error,
      };
    case types.PRIMARY_MUSCLE_SINGLE:
      return {
        ...state,
        primaryMuscleSingle: payload,
        error,
      };
    case types.PRIMARY_MUSCLE_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default PrimaryMuscle;
